import todoStore from "./todo";

const store = { todoStore };
export default store;
